var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.resultantAttrs && _vm.resultantAttrs.length)?_c('div',{staticClass:"product-card__attrs-tags d-flex align-center",class:{
		'justify-center': _vm.manager.configData.alignment == 'center',
		'justify-end': _vm.manager.configData.alignment == 'right',
	},staticStyle:{"gap":"6px"}},_vm._l((_vm.resultantAttrs),function(ref,index){
	var v = ref.v;
return _c('span',{key:index,class:['secondary font-0 font-weight-medium line-clamp-1 pa-1']},[_vm._v(" "+_vm._s(v)+" ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }